import React from 'react';
import { Card, CardBody, CardHeader, Row, Col, Table } from 'reactstrap';

const money = (n) =>
  Number(n || 0).toLocaleString('es-EC', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const ResumenPoliza = ({ data }) => {
  // Puede venir como "carrito completo" o con "producto" ya extraído
  const carrito = data || {};
  const producto =
    (carrito && carrito.producto) ||
    (Array.isArray(carrito.carProductos) && carrito.carProductos[0]) ||
    {};
  console.log("🚀 ~ ResumenPoliza ~ producto:", producto)

  const empresa = carrito.datosContratanteEmpresa || {};
  const solicitante =
    carrito.datosContratantePersona || carrito.carDatosContratante || {};
  const ubicacion = carrito.datosUbicacion || {};
  const provincia = ubicacion.provincia || {};
  const ciudad = ubicacion.ciudad || {};
  const broker = carrito.carDatosAsesor || {};

  const planes = Array.isArray(producto.planes) ? producto.planes : [];
  const pagadores = Array.isArray(producto.pagadores) ? producto.pagadores : [];
  const asegurados = Array.isArray(producto.asegurados) ? producto.asegurados : [];

  const tipo_pago = producto.tipo_pago || {};
  const forma_pago =
    (producto.forma_pago && producto.forma_pago.label) ||
    (producto.formaPago && producto.formaPago.label) ||
    '';

  const renderTable = (headers, rows) => (
    <Table bordered hover responsive className="rounded border">
      <thead className="table-light">
        <tr>{headers.map((h, i) => <th key={i}>{h}</th>)}</tr>
      </thead>
      <tbody>
        {rows && rows.length ? (
          rows
        ) : (
          <tr>
            <td colSpan={headers.length} className="text-center">
              Sin registros
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );

  const renderCoberturas = (cobs) =>
    renderTable(
      ['Código', 'Cobertura', 'Suma asegurada', 'Tasa', 'Prima', 'Deducible'],
      (Array.isArray(cobs) ? cobs : []).map((c, idx) => (
        <tr key={idx}>
          <td>{c && c.cod_riesgo}</td>
          <td>{c && c.nombre}</td>
          <td>{c && c.sumaAsegurada}</td>
          <td>{c && c.tasa}</td>
          <td>{money(c && c.prima)}</td>
          <td>{(c && (c.deducible !== undefined ? c.deducible : '—'))}</td>
        </tr>
      ))
    );

  const renderAsistencias = (asis) =>
    renderTable(
      ['Código', 'Asistencia', 'Prima'],
      (Array.isArray(asis) ? asis : []).map((a, idx) => (
        <tr key={idx}>
          <td>{a && a.codigo}</td>
          <td>{a && a.nombre}</td>
          <td>{money(a && a.prima)}</td>
        </tr>
      ))
    );

  return (
    <div className="container mt-4">
      {/* INFORMACIÓN DE LA EMPRESA */}
      <Card className="mb-4 shadow-sm border-0 rounded">
        <CardHeader><strong>INFORMACIÓN DE LA EMPRESA</strong></CardHeader>
        <CardBody>
          <Row>
            <Col md="6"><strong>RUC:</strong> {empresa.cliIdentificacion || '-'}</Col>
            <Col md="6"><strong>Nombre:</strong> {empresa.cliRazonSocial || '-'}</Col>
            <Col md="6"><strong>Actividad:</strong> {producto.actividad || '-'}</Col>
            <Col md="6"><strong>Provincia:</strong> {provincia.label || '-'}</Col>
            <Col md="6"><strong>Ciudad:</strong> {ciudad.label || '-'}</Col>
            <Col md="6"><strong>Dirección:</strong> {ubicacion.direccion || '-'}</Col>
          </Row>
        </CardBody>
      </Card>

      {/* SOLICITANTE */}
      <Card className="mb-4 shadow-sm border-0 rounded">
        <CardHeader><strong>SOLICITANTE</strong></CardHeader>
        <CardBody>
          <Row>
            <Col md="6"><strong>Cédula:</strong> {(solicitante.cliIdentificacion || solicitante.identificacion) || '-'}</Col>
            <Col md="6"><strong>Nombre:</strong> {solicitante.nombreCompleto || ((solicitante.nombres || '') + ' ' + (solicitante.apellidos || '')) || '-'}</Col>
          </Row>
        </CardBody>
      </Card>

      {/* BROKER */}
      <Card className="mb-4 shadow-sm border-0 rounded">
        <CardHeader><strong>BROKER</strong></CardHeader>
        <CardBody>
          <Row>
            <Col md="6"><strong>Nombre:</strong> {broker.brokerNombre || broker.nombre || '-'}</Col>
            <Col md="6"><strong>Email:</strong> {broker.emailAsesor || '-'}</Col>
          </Row>
        </CardBody>
      </Card>

      {/* VIGENCIA Y FACTURACIÓN */}
      <Card className="mb-4 shadow-sm border-0 rounded">
        <CardHeader><strong>VIGENCIA Y FACTURACIÓN</strong></CardHeader>
        <CardBody>
          <Row>
            <Col md="6"><strong>Tipo de pago:</strong> {tipo_pago.label || '-'}</Col>
            <Col md="6"><strong>Forma de pago:</strong> {forma_pago || '-'}</Col>
            <Col md="6"><strong>Fecha inicio:</strong> {producto.fecha_v_inicio || '-'}</Col>
            <Col md="6"><strong>Fecha fin:</strong> {producto.fecha_v_fin || '-'}</Col>
            <Col md="6"><strong>Blanket:</strong> {producto.blanket ? 'SÍ' : 'NO'}</Col>
          </Row>
        </CardBody>
      </Card>

      {/* PLANES + COBERTURAS + ASISTENCIAS */}
      <Card className="mb-4 shadow-sm border-0 rounded">
        <CardHeader><strong>PLANES</strong></CardHeader>
        <CardBody>
          {renderTable(
            ['Nombre', 'Detalle'],
            planes.map((p, i) => (
              <tr key={i}>
                <td style={{ width: 220 }}>{p && p.nombre}</td>
                <td>
                  {/* Datos del plan */}
                  <div><strong>Prima Neta:</strong> {money(p && p.primaNeta)}</div>
                  <div><strong>Prima Total (Bruta):</strong> {money(p && p.primaTotal)}</div>
                  <div><strong>Edad Mínima:</strong> {producto && producto.edadMinima}</div>
                  <div><strong>Edad Máxima:</strong> {producto && producto.edadMaxima}</div>
                  {p && p.esCondicional === 'si' && (
                    <>
                      <div><strong>Condición:</strong> {p.tipoCondicional} — {p.valorCondicional}{p.tipoCondicional === 'porcentaje' ? '%' : ''}</div>
                      {p.planCondicion && <div><strong>Aplica sobre:</strong> {p.condicion.dependeDePlanNombre}</div>}
                    </>
                  )}

                  {/* Coberturas */}
                  <div className="mt-3">
                    <strong>Coberturas</strong>
                    {renderCoberturas(p && p.coberturas)}
                  </div>

                  {/* Asistencias */}
                  <div className="mt-3">
                    <strong>Asistencias</strong>
                    {renderAsistencias(p && p.asistencias)}
                  </div>
                </td>
              </tr>
            ))
          )}
        </CardBody>
      </Card>

      {/* CONTRATANTES */}
      <Card className="mb-4 shadow-sm border-0 rounded">
        <CardHeader><strong>CONTRATANTES</strong></CardHeader>
        <CardBody>
          {renderTable(
            ['Nombre', 'Identificación', 'Correo', 'Celular', 'Dirección'],
            pagadores.map((p, i) => (
              <tr key={i}>
                <td>{(p && (p.nombreCompleto || p.nombre)) || '-'}</td>
                <td>{(p && (p.cliIdentificacion || p.identificacion)) || '-'}</td>
                <td>{(p && (p.email || p.correo)) || '-'}</td>
                <td>{(p && (p.celular || p.telefono)) || '-'}</td>
                <td>{(p && p.direccion) || '-'}</td>
              </tr>
            ))
          )}
        </CardBody>
      </Card>
        {producto.blanket&&(
             <Card className="mb-4 shadow-sm border-0 rounded">
          <CardHeader><strong>ASEGURADOS</strong></CardHeader>
          <CardBody>
            {producto.numPersonas+" asegurados"}
          </CardBody>
        </Card>
        )}
      {/* ASEGURADOS (si no es blanket) */}
      {!producto.blanket && (
        <Card className="mb-4 shadow-sm border-0 rounded">
          <CardHeader><strong>ASEGURADOS</strong></CardHeader>
          <CardBody>
            {renderTable(
              ['Nombre', 'Identificación', 'Plan', 'Contratante'],
              asegurados.map((a, i) => (
                <tr key={i}>
                  <td>{a && a.nombre}</td>
                  <td>{a && a.identificacion}</td>
                  <td>{a && a.plan ? a.plan.nombre : '-'}</td>
                  <td>{a && a.contratante ? (a.contratante.nombreCompleto || a.contratante.nombre) : '-'}</td>
                </tr>
              ))
            )}
          </CardBody>
        </Card>
      )}
    </div>
  );
};

export default ResumenPoliza;
